export const SUCCESS_MESSAGE = "Api Call: Success";
export const BUTTON_TEXT = "Trigger Query";
